import React from 'react';
import styled, { keyframes } from 'styled-components';
import { TokenSet } from '../../styles/tokens';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Ring = styled.div<{ tokens: TokenSet; size?: number }>`
  width: ${p => p.size || 40}px;
  height: ${p => p.size || 40}px;
  border: 3px solid ${p => p.tokens.border};
  border-top-color: ${p => p.tokens.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const Loader: React.FC<{ tokens: TokenSet; size?: number; fullPage?: boolean }> = ({ tokens, size, fullPage }) => {
  if (fullPage) {
    return (
      <Center style={{ minHeight: '100vh' }}>
        <Ring tokens={tokens} size={size} />
      </Center>
    );
  }
  return (
    <Center>
      <Ring tokens={tokens} size={size} />
    </Center>
  );
};
